module.exports = __webpack_public_path__ + "static/media/insta5.3e83fb30.jpg";